import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import DashboardSearchCriteria from 'src/app/interfaces/dashboardSearchCriteria';

@Component({
    selector: 'app-dashboardgridsearch',
    templateUrl: './dashboardgridsearch.component.html',
    styleUrls: ['./dashboardgridsearch.component.scss'],
    standalone: false
})
export class DashboardgridsearchComponent {
  timer: any;
  searchCriteria: DashboardSearchCriteria = { searchString: '' };

  constructor() { }

  ngOnInit(): void {
  }
    @Output() emitter:EventEmitter<DashboardSearchCriteria> = new EventEmitter<DashboardSearchCriteria>();

    @ViewChild('keyword') keyword : ElementRef | undefined;
    timeout: any;

    ngOnAfterViewInit() {
      this.setFocus();
    }

    emit(keyword:string) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchCriteria.searchString = keyword;
        this.emitter.emit(this.searchCriteria);
      }, 500);
  }
  
  setFocus() {
    if(this.keyword) {
      this.keyword.nativeElement.focus();
    }
  }

}
